export default {
  locales: [
    {
      code: 'en',
      name: 'English',
      dir: 'ltr',
      flag: 'gb'
    },
    {
      code: 'zh',
      name: '中文',
      dir: 'ltr',
      flag: 'cn'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/config.js